module.exports = __webpack_public_path__ + "4ff8cc9615dbca5f610bc9e0d568aac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_3-872.jpg
// module id = 596
// module chunks = 0